import styled from 'styled-components';

export const Wrapper = styled.div<{ $grainIntensity: number }>`
  flex: 1;
  display: flex;
`;

export const Header = styled.div`
  position: absolute;
  left: 50%;
  top: 60px;
  transform: translateX(-50%);
  padding: 20px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
  font-size: 20px;
  display: none;
`;
